"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.airPage = airPage;
const value_1 = require("./value");
const Freon = __importStar(require("./freon"));
const Fluid = __importStar(require("./fluid"));
const Steam = __importStar(require("./steam"));
function airPage(coilType, si) {
    const values = getValues(coilType);
    return values.map(v => [
        (0, value_1.getHeaderName)(v),
        (0, value_1.getValue)(v, si),
        (0, value_1.getHeaderUnit)(v, si)
    ]);
}
function getValues(coilType) {
    switch (coilType) {
        case "fluid-cooling":
            return Fluid.fluid(false).concat(Fluid.fluid(true));
        case "fluid-heating":
            return Fluid.fluid(false);
        case "dx":
            return Freon.freon(false).concat(Freon.freon(true));
        case "condenser":
            return Freon.freon(false);
        case "steam":
            return Steam.steam();
        default:
            throw new Error("Unknown coil type");
    }
}
//# sourceMappingURL=air-page.js.map